import axiosClient from "../../utils/axiosInstance";
import { AdminSubmitFRQPayload, AdminSubmitMCQPayload } from "../types/adminQuestionTypes";


export const getMultipleChoiceQuestions = (page:number) => {
  const response = axiosClient().get(`/questions/mcq/${page}`);
  return response;
};

export const saveMCQ = (payload:AdminSubmitMCQPayload) => {
  const response = axiosClient().post('/questions/mcq/add', { ...payload });
  return response;
};

export const updateMCQ = (customId:string, payload:AdminSubmitMCQPayload) => {
  const response = axiosClient().put(`/questions/mcq/${customId}`, {
    ...payload
  });
  return response;
};
export const deleteMCQ = (customId:string) => {
  const response = axiosClient().delete(`/questions/mcq/remove/${customId}`);
  return response;
};

export const getFreeResponseQuestions = (page:number) => {
  const response = axiosClient().get(`/questions/free-response/${page}`);
  return response;
};

export const saveFreeResponseQuestion = (payload:AdminSubmitFRQPayload) => {
  const response = axiosClient().post('/questions/free-response/add', {
    ...payload
  });
  return response;
};

export const updateFreeResponseQuestion = (customId:string, payload:AdminSubmitFRQPayload) => {
  const response = axiosClient().put(`/questions/free-response/${customId}`, {
    ...payload
  });
  return response;
};

export const deleteFreeResponseQuestions = (customId:string) => {
  const response = axiosClient().delete(
    `/questions/free-response/remove/${customId}`
  );
  return response;
};

export const getAllCodeQuestions = (page:number) => {
  const response = axiosClient().get(`/questions/code/${page}`);
  return response;
};

